export const environment = {
  production: true,
  configLoaded: false,
  name: ".prod"
};
